import { createSelector } from '@reduxjs/toolkit';
import type { Store } from 'store/types/types';

export const getActiveCropId = (state: Store) => state.current?.cropId;
export const getActiveCropNominalWeight = createSelector(
  [(state: Store) => state.crops, getActiveCropId ],
  (crops, activaCropId) => crops?.[activaCropId]?.['nominal-weight']?.q
);
